/*$("body").on("click", ".cushion-fabric-wrapper", function (e) {
  e.preventDefault();
  $(this)
    .parents(".custom_options_selection_field")
    .find(".custom-option-outer")
    .show();
  $(this).toggleClass("enabled");
  $('.cushion-product-dropdown').removeClass('is-active');
  $('.cushion-product-variant-picker').hide();
  $("ul.custom-option-list").toggle();
});

$("body").on("click", "ul.custom-option-list li", function () {
  let listvaluesItem = $(this).text();
//  console.log('listvaluesItem', listvaluesItem)
  $("ul.custom-option-list li").removeClass("active");
  $(this).addClass("active");
  $("span.selected-fabric").text(listvaluesItem); 
  $("input#custom-location").val(listvaluesItem);
  $(".custom_options_selection_field").addClass("active");
  $("ul.custom-option-list").hide();

  if(!$(this).parent().parent().find('.cushion-fabric-wrapper').hasClass('is-active')) {
    $(this).parent().parent().find('.cushion-fabric-wrapper').addClass('is-active');
  } 
  
});

// ----------------- Search Code ---------------------------
$(document).on("keyup", "#custom-option-search", function () {
  const searchText = $(this).val().toLowerCase();

  $(".custom-option-list li").each(function () {
    const text = $(this).text().toLowerCase();
    $(this).toggle(text.includes(searchText));
  });
});


// ---------------------------------------------------------

$("body").on("click", "ul.options.cushion-list-item li", function () {
  var getliVal = $(this).attr("data-value");
  $("span.selected-fabric").text(getliVal);
  $("input#custom-location").val(getliVal);

  toggleSubmitButton();
});

$("body").on("click", ".cushion-product-dropdown", function (e) {
  e.stopPropagation(); // prevent bubbling to document

  $('.cushion-fabric-wrapper').removeClass('enabled');
  $('.custom-option-list').hide();
  // Toggle this specific dropdown only
  $(this).toggleClass("is-active");
  $(".select.cushion-product-variant-picker")
    .not($(this).find(".select.cushion-product-variant-picker"))
    .hide(); // hide all others
  $(this).find(".select.cushion-product-variant-picker").toggle(); // toggle current
});


$("body").on("click", ".custom-select li", function () {
  var listitemText = $(this).attr("data-value");

  $("span.selected-fabric").text(listitemText);
  $("input#custom-location").val(listitemText);
});

$("body").on("click", ".option--name--0 ul.select__select li", function (e) {
  e.stopPropagation();
  var selectedValue = $(this).attr("value") || $(this).text().trim();

  $("span.selected-size").text(selectedValue);
  $(".option--name--0 ul.select__select li").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".product-form__input--dropdown").addClass("active");
  $(this).closest(".select.cushion-product-variant-picker").hide();
});

$("body").on("click", ".option--name--1 ul.select__select li", function (e) {
  e.stopPropagation();

  var selectedValueedge = $(this).attr("value") || $(this).text().trim();

  $("span.selected-edge-style").text(selectedValueedge);
  $(".option--name--1 ul.select__select li").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".product-form__input--dropdown").addClass("active");
  $(this).closest(".select.cushion-product-variant-picker").hide();
});

// option 1

// add to cart id
$("body").on(
  "click",   ".cushion-product-dropdown.option--name--0 li",
  function () {
    // Size selection
    var selectedValueFabric = $(this).text().trim();
    $("span.selected-size").text(selectedValueFabric);
    $(this).addClass("active").siblings().removeClass("active");
    toggleSubmitButton();
    updateVariantCombination();
  }
);

$("body").on("click", ".cushion-product-dropdown.option--name--1 li",
  function () {
    // Edge selection
    var selectedValueEdge = $(this).text().trim();
    $("span.selected-edge-style").text(selectedValueEdge);
    $(this).addClass("active").siblings().removeClass("active");
    toggleSubmitButton();
    updateVariantCombination();
  }
);

function updateVariantCombination() {
  var selectedValueFabric = $(
    ".cushion-product-dropdown.option--name--0 li.active"
  ).text().trim();
  var selectedValueEdge = $(
    ".cushion-product-dropdown.option--name--1 li.active"
  ).text().trim();

  if (!selectedValueFabric || !selectedValueEdge) return;

  var combination = selectedValueFabric + " / " + selectedValueEdge;

  var matchFound = false;

  $(".hidden-variants li").each(function () {
    var getText = $(this).text().trim();

    if (combination === getText) {
      matchFound = true;
      var variantId = $(this).data("id");
      var variantprice = $(this).data("price");
      $("input.product-variant-id").val(variantId);
      $('input[name="id"]').val(variantId);
      $('.price-item--regular').text(variantprice);
      return false; // Stop loop
    }
  });

  if (!matchFound) {
    console.log("✖ No matching variant found");
    $('input[name="id"]').val("");
  }
}

function toggleSubmitButton() {
  var sizeText = $("span.selected-size").text().trim();
  var edgeText = $("span.selected-edge-style").text().trim();
  var fabricText = $("span.selected-fabric").text().trim();

  if (sizeText === "" || edgeText === "" || fabricText === "") {
    $(".tempproduct-cushion-product button.product-form__submit").attr(
      "disabled",
      true
    );
  } else {
    $(".tempproduct-cushion-product button.product-form__submit").removeAttr(
      "disabled"
    );
  }

  if(fabricText != ''){
    $('.cushion-fabric-wrapper').addClass('is-active');
  } 
  if(sizeText != ''){
    $('.cushion-product-dropdown.option--name--0').addClass('active');
  }
  if(edgeText != ''){
    $('.cushion-product-dropdown.option--name--1').addClass('active');
  }
}

// Initial check on load
// $(document).ready(function () {
//   toggleSubmitButton();
// });

// Observe body for any DOM changes and call toggleSubmitButton
const observer = new MutationObserver(function () {
  toggleSubmitButton();
});
observer.observe(document.body, {
  childList: true,
  subtree: true,
});
*/
// ----------------------Sample Button Add to Cart------------------------

document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".custom_main_product_freesample");
  const elementid = document.getElementById("Add_sample_cart");

  if (!button || !elementid) return;

  const variantId = elementid.dataset.vid;

  button.addEventListener("click", function (e) {
    e.preventDefault();

    if (!variantId) {
      console.error("Variant ID not found.");
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Add to cart failed");
        return res.json();
      })
      .then(() => {
        if (typeof refreshCartDrawer === "function") {
          refreshCartDrawer(); // optional: update cart drawer if function exists
        }
      })
      .catch((err) => {
        console.error("Error adding sample to cart:", err);
      });
  });
});
function updateCartBubble() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const bubble = document.getElementById("cart-icon-bubble");
      const countSpan = bubble?.querySelector('[aria-hidden="true"]');

      if (!bubble || !countSpan) return;

      if (cart.item_count > 0) {
        countSpan.textContent = cart.item_count;
        bubble.style.display = "inline-block";
      } else {
        bubble.style.display = "none";
      }
    })
    .catch((err) => console.error("[Cart Bubble] Error:", err));
}

function refreshCartDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const cartDrawerItems = document.querySelector("cart-drawer-items");
  const cartDrawerCheckout = document.querySelector("#CartDrawer-Checkout");

  if (cartDrawer) {
    cartDrawer.classList.remove("is-empty");

    const emptyDrawerElement = cartDrawer.querySelector(".drawer__inner-empty");
    if (emptyDrawerElement) emptyDrawerElement.remove();

    const cartContentsForm = document.querySelector(".cart__contents");
    if (cartContentsForm) cartContentsForm.style.display = "block";

    if (cartDrawerCheckout) cartDrawerCheckout.removeAttribute("disabled");

    if (!cartDrawerItems) {
      const newCartItems = document.createElement("cart-drawer-items");
      const drawerHeader = document.querySelector(".drawer__header");
      if (drawerHeader) {
        drawerHeader.insertAdjacentElement("afterend", newCartItems);
      }
    }

    const updatedCartItems = document.querySelector("cart-drawer-items");
    if (
      updatedCartItems &&
      typeof updatedCartItems.onCartUpdate === "function"
    ) {
      updatedCartItems.onCartUpdate();
    }

    if (typeof cartDrawer.open === "function") {
      cartDrawer.open();
    } else {
      cartDrawer.classList.add("is-open");
      document.body.classList.add("overflow-hidden");
    }
  }
  updateCartBubble();
}
